import Vue from 'vue'
import Router from 'vue-router'
import headers from '@/components/header'
import Tabs from '@/components/tab'
import login from '@/pages/login'
import Home from '@/pages/home'
import deals from '@/pages/deal'
import Hold from '@/pages/hold'
import PendingOrder from '@/pages/pendingOrder'
import Transaction from '@/pages/transaction'
import History from '@/pages/history'
import Dealprices from '@/components/dealprice'
import pingcangs from '@/components/pingcang'
import shixiaos from '@/components/shixiao'
import mingxis from '@/components/mingxi'
import silvers from '@/components/silver'
import golds from '@/components/gold'
import revisepages from '@/components/revisepage'
import store from '../store'

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{requireAuth: true}
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      
    },
    {
      path: '/header',
      name: 'headers',
      component: headers
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/tab',
      name: 'tabs',
      component: Tabs,
      children: [ 
        {name: 'deals', path: '/deal', component: deals, meta:{requireAuth: true} }, 
        {name: 'holds', path: '/hold', component: Hold,  meta: {requireAuth: true}},
        {name: 'pendingOrders', path: '/pending-Order', component: PendingOrder, meta: {requireAuth: true}}, 
        {name: 'transactions', path: '/transaction', component: Transaction},
        {
          name: 'historys', path: '/history', component: History, meta: {requireAuth: true},
          children:[
            {name:'pingcangs',path:'/history',component:pingcangs},
            {name:'shixiaos',path:'/history/shixiao',component:shixiaos},
            {name:'mingxis',path:'/history/mingxi',component:mingxis}
          ],
          
        }
      ] 
    },
    {
      path: '/dealprice',
      name: 'dealprices',
      component: Dealprices
    },
    {
      path: '/gold',
      name: 'golds',
      component: golds
    },
    {
      path: '/silver',
      name: 'silvers',
      component: silvers
    },
    {
      path: '/revisepage',
      name: 'revisepages',
      component: revisepages
    },
  ]

})

export default router


 




// WEBPACK FOOTER //
// ./src/router/index.js